import {Component, inject} from '@angular/core';
import {Location, NgClass} from "@angular/common";
import {FarmReference} from "src/app/infrastructure/moovement-api/models/farm";
import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";
import {HomesteadSvgComponent} from "src/app/presentation/common/icons/homestead-svg/homestead-svg.component";
import {BootstrapService} from "src/app/infrastructure/init/bootstrap.service";
import {FarmStore} from 'src/app/domain/assets/farm/farm.store';
import {Router} from '@angular/router';
import {ViewportService} from 'src/app/infrastructure/viewport.service';
import {MainViewStore} from 'src/app/presentation/main-view/main-view.store';
import {FarmService} from 'src/app/domain/assets/farm/farm.service';
import {PaddockService} from 'src/app/domain/assets/paddocks/paddock.service';
import {AggregatedAssetStateStore} from 'src/app/domain/assets/aggregated-state/aggregated-asset-state.store';
import {FixedSamplePointsService} from 'src/app/domain/assets/fixed-sample-points/fixed-sample-points.service';
import {GatewayService} from 'src/app/domain/devices/gateway/gateway.service';
import {AnimalsService} from 'src/app/domain/assets/animals/animals.service';
import {DeviceService} from 'src/app/domain/devices/device.service';
import {DeviceAssociationService} from 'src/app/domain/devices/device-association.service';
import {AggregatedDeviceStateStore} from 'src/app/domain/devices/aggregated-state/aggregated-device-state.store';
import {WaterPointsService} from 'src/app/domain/assets/water-points/water-points.service';

@Component({
  selector: 'app-farms',
  imports: [
    HomesteadSvgComponent,
    NgClass
  ],
  templateUrl: './farms.component.html',
  styleUrl: './farms.component.css'
})
export class FarmsComponent {

  farmReferences: Array<FarmReference> = []
  filteredFarmReferences: Array<FarmReference> = []

  farmStore = inject(FarmStore);

  private aggregatedAssetStateStore = inject(AggregatedAssetStateStore);
  private aggregatedDeviceStateStore = inject(AggregatedDeviceStateStore);
  private location = inject(Location);
  private mainViewStore = inject(MainViewStore);
  private paddockService = inject(PaddockService);
  private router = inject(Router);

  constructor(
    protected dataSubscriptionService: DataSubscriptionService,
    protected viewportService: ViewportService,
    private animalService: AnimalsService,
    private bootstrapService: BootstrapService,
    private deviceAssociationService: DeviceAssociationService,
    private deviceService: DeviceService,
    private farmService: FarmService,
    private fixedSamplePointsService: FixedSamplePointsService,
    private gatewayService: GatewayService,
    private waterPointService: WaterPointsService
  ) {
    dataSubscriptionService.onFirst<Array<FarmReference>>('farmReferences').subscribe(farmReferences => {
      this.farmReferences = farmReferences
      this.filteredFarmReferences = this.farmReferences;
    })
  }

  filterResults(target: any) {
    if (!target.value) {
      this.filteredFarmReferences = this.farmReferences
      return;
    }
    this.filteredFarmReferences = this.farmReferences.filter(
      farmReference => farmReference?.label.toLowerCase().includes(target.value.toLowerCase())
    );
  }

  focusOnFarm(farmReference: FarmReference) {
    this.router.navigate(['/main/information-center']);
    this.aggregatedAssetStateStore.reset();
    this.aggregatedDeviceStateStore.reset();
    this.farmService.reset();
    this.animalService.reset();
    this.fixedSamplePointsService.reset();
    this.gatewayService.reset();
    this.deviceService.reset();
    this.deviceAssociationService.reset();
    this.paddockService.reset();
    this.waterPointService.reset();

    this.bootstrapService.populateFarmWithAssets(farmReference);
  }

  protected back(): void {
    this.location.back();
  }

  close() {
    this.mainViewStore.hideChildComponent();
  }
}
